/**
 * CanvasEmptyState — placeholder for the right pane of /assistant when no
 * artifact has been pinned yet. Explains the pin behaviour and gives a
 * keyboard hint matching the global ⌘K shortcut.
 */

import { t } from '../../../i18n/index.js'

export function CanvasEmptyState() {
  return (
    <div class="ion-canvas-empty">
      <div class="ion-canvas-empty__icon" aria-hidden="true">
        <CanvasIcon />
      </div>
      <h3 class="ion-canvas-empty__title">{t('ion.canvas.empty.title')}</h3>
      <p class="ion-canvas-empty__body">{t('ion.canvas.empty.body')}</p>
      <p class="ion-canvas-empty__hint">
        {/* {kbd} stays literal in the template so we can swap in JSX */}
        {t('ion.canvas.empty.hint')
          .split('{kbd}')
          .reduce((acc, part, i, arr) => {
            acc.push(part)
            if (i < arr.length - 1) acc.push(<kbd key={i}>⌘K</kbd>)
            return acc
          }, [])}
      </p>
    </div>
  )
}

function CanvasIcon() {
  return (
    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 9h18" />
      <path d="M9 21V9" />
    </svg>
  )
}
